export enum NeoCardListView {
  listView = 1,
  gridView = 3
}

export enum StorageLocation {
  localStorage = 'localStorage',
  queryParams = 'queryParams'
}
